module.exports = __webpack_public_path__ + "img/approved.a3b5935b.svg";